export default {
    isValidAddress(address, currency, networkType) {
        if (address.length < 2 || address.length > 64) {
            return false;
        }
        const regex = /^(([a-z\d]+[-_])*[a-z\d]+\.)*([a-z\d]+[-_])*[a-z\d]+$/i;
        return address.search(regex) !== -1;
    },
};
